import { OauthBrowserService } from './oauth-browser.service';

export default angular
  .module('sfMobile.services.oAuth-browser', [
    'sfMobile.services.in-app-browser',
  ])
  .service('oAuthBrowserService', OauthBrowserService).name;
